import React from 'react';
import PropTypes from 'prop-types';
import { propOr } from 'ramda';
import { getIn } from 'formik';

import './form.scss';

const TextInput = ({
  field,
  form,
  label,
  labelClassName,
  className,
  containerClass,
  isFSblocked,
  isRequired,
  type,
  ...props
}) => {
  const name = propOr('', 'name')(field);
  const errors = propOr({}, 'errors')(form);
  const touched = propOr({}, 'touched')(form);
  const error = getIn(errors, name);
  const hasError = getIn(touched, name) && error;
  const invalidClass = hasError ? 'is-invalid' : '';
  const fsClass = isFSblocked ? 'fs-block' : '';

  return (
    <div className={`form__input-container ${containerClass}`}>
      {label && (
        <label htmlFor={name} className={`form__label ${labelClassName}`}>
          {label} {isRequired && <span className="text-pink">*</span>}
        </label>
      )}
      <input
        className={`form__input ${className} ${fsClass} ${invalidClass}`}
        id={name}
        type={type}
        {...field}
        {...props}
      />
      {hasError && <div className="form__error">{error}</div>}
    </div>
  );
};

TextInput.propTypes = {
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  containerClass: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  field: PropTypes.shape({}).isRequired,
  form: PropTypes.shape({}).isRequired,
  isFSblocked: PropTypes.bool,
  isRequired: PropTypes.bool,
};

TextInput.defaultProps = {
  label: '',
  className: '',
  labelClassName: '',
  containerClass: '',
  isFSblocked: false,
  isRequired: false,
  type: 'text',
};

export default TextInput;
